export const env = {
  appName: import.meta.env.VITE_APP_NAME ?? 'Draw',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  isProduction: import.meta.env.PROD,
  /** The local dev server, where Netlify Identity does not run and everyone is `dev`. */
  localDev: import.meta.env.DEV,
} as const;
